<template>
  <v-card>
    <div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cancel" fab class="error" x-small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <notification-detail-content
          :item="notificationItem"
          :isClient="isClient"
          :isAdmin="isAdmin"
          :isTeamMember="isTeamMember"
          :userId="userId"
          @initNotifications="initNotifications"
          @successRaise="successRaise"
          @errorRaise="errorRaise"
        />
        <br />
      </v-card-text>
    </div>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import NotificationDetailContent from "./NotificationDetailContent.vue";

export default defineComponent({
  components: {
    NotificationDetailContent,
  },
  props: {
    notificationItem: {
      type: Object,
    },
    userId: {
      type: String,
    },
    isClient: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isTeamMember: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  async mounted() {
    this.$emit("makeSeen", this.notificationItem);
  },
  methods: {
    initNotifications() {
      this.$emit("initNotifications");
    },
    errorRaise(msg: any) {
      this.$emit("errorRaise", msg);
    },
    successRaise(msg: any) {
      this.$emit("successRaise", msg);
    },
    cancel() {
      this.$emit("cancel");
    },
  },
});
</script>
